class DataService {
  constructor() {
    // 检查是否在 Electron 环境中运行
    this.isElectron = window.electron !== undefined;
    
    if (this.isElectron) {
      const fs = window.require('fs');
      const path = window.require('path');
      const { app } = window.require('@electron/remote');
      
      // 获取用户数据目录
      this.dataPath = path.join(app.getPath('userData'), 'talent-data.json');
      
      // 确保文件存在
      if (!fs.existsSync(this.dataPath)) {
        fs.writeFileSync(this.dataPath, JSON.stringify({ employees: [] }));
      }
    } else {
      // 在浏览器环境中使用 localStorage
      if (!localStorage.getItem('talent-data')) {
        localStorage.setItem('talent-data', JSON.stringify({ employees: [] }));
      }
    }
  }

  // 读取数据
  loadData() {
    try {
      if (this.isElectron) {
        const fs = window.require('fs');
        const data = fs.readFileSync(this.dataPath, 'utf8');
        return JSON.parse(data);
      } else {
        // 从 localStorage 读取数据
        const data = localStorage.getItem('talent-data');
        return JSON.parse(data);
      }
    } catch (error) {
      console.error('Error loading data:', error);
      return { employees: [] };
    }
  }

  // 保存数据
  saveData(data) {
    try {
      if (this.isElectron) {
        const fs = window.require('fs');
        fs.writeFileSync(this.dataPath, JSON.stringify(data, null, 2));
      } else {
        // 保存到 localStorage
        localStorage.setItem('talent-data', JSON.stringify(data));
      }
      return true;
    } catch (error) {
      console.error('Error saving data:', error);
      return false;
    }
  }
}

export default new DataService(); 